import React from 'react';
import {Input} from "@/components/ui/input";
import {Button} from "@/components/ui/button";
import PageBanner from "@/components/pageBanner";

const Login = () => {
    return (
        <>
            <PageBanner title="Login" />
            <section className="container flex flex-col items-center justify-center py-14">
                <div className="w-full max-w-md space-y-8">
                    <form>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-black">Email</label>
                                <Input type="email" placeholder="Email" required/>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-black">Password</label>
                                <Input type="password" placeholder="Password" required/>
                            </div>
                        </div>
                        <Button type="submit" className="small-button dark-variant mt-4">
                            Log in
                        </Button>
                    </form>
                </div>
            </section>
        </>
    );
};

export default Login;